/*
 * Copyright (c) ${year}. Sayari LLC
 */

export class RegistrationModel {
    businessName: string;
    streetAddress1: string;
    streetAddress2: string;
    city: string;
    state: string;
    zipCode: string;
    phoneNumber: string;
    website: string;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
}
